import React, { createContext, useContext, useState, useEffect } from "react";
import { io } from "socket.io-client";
import { BASE_URL_FLASK, BASE_URL_NODE } from "../services/serviceUrls";

// Create the Context
const DataContext = createContext();

// Create the Provider component
export const DataProvider = ({ children }) => {
  const [state, setState] = useState({
    models: [],
    selected_model: null,
    selected_status: 0,
    loading: false,
    selected_index: null,
    tables: [], // Available tables
    selected_table: "", // Selected table name
    selected_task_id: "", // Selected task ID for task-specific data
    selected_task_type: "", // Selected task type (classification, alignment, etc.)
    editorOpen: false, // Initialize editorOpen state
    // glb_model: "",
  });

  const [socket, setSocket] = useState(null);

  // Fetch available tables on mount
  useEffect(() => {
    const fetchTables = async () => {
      try {
        const response = await fetch(`${BASE_URL_FLASK}/tables`);
        const tables = await response.json();
        setState((prev) => ({
          ...prev,
          tables: tables.tables, // <-- Fix: use the array, not the object
        }));
      } catch (error) {
        console.error("Error fetching tables:", error);
      }
    };

    fetchTables();
  }, []);

  // Fetch data when a table is selected
  useEffect(() => {
    if (!state.selected_table || state.selected_task_id) return; // Skip if task is selected

    const fetchData = async () => {
      setState((prev) => ({ ...prev, loading: true }));

      try {
        const response = await fetch(
          `${BASE_URL_FLASK}/data?table_name=${state.selected_table}`
        );
        const result = await response.json();
        setState((prev) => ({
          ...prev,
          models: result,
          loading: false,
        }));
      } catch (error) {
        console.error("Error fetching data:", error);
        setState((prev) => ({ ...prev, loading: false }));
      }
    };

    fetchData();
  }, [state.selected_table]);

  // Fetch data when a task is selected
  // Note: This useEffect is removed - we'll call fetchTaskData manually when needed

  // const fetchTaskData = async (taskId) => {
  //   if (!taskId) return;

  //   setState((prev) => ({ ...prev, loading: true }));

  //   try {
  //     const token = localStorage.getItem("access_token");
  //     const response = await fetch(`${BASE_URL_FLASK}/user/tasks/${taskId}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const result = await response.json();
  //     console.log("Task API response:", result);

  //     // Handle different possible response structures
  //     let models = [];
  //     if (result.assigned_task_ids && Array.isArray(result.assigned_task_ids)) {
  //       models = result.assigned_task_ids;
  //     } else if (result.models) {
  //       models = result.models;
  //     } else if (result.data) {
  //       models = result.data;
  //     } else if (Array.isArray(result)) {
  //       models = result;
  //     } else {
  //       console.warn("Unexpected API response structure:", result);
  //     }

  //     console.log("Extracted models:", models);

  //     setState((prev) => ({
  //       ...prev,
  //       models: Array.isArray(models) ? models : [],
  //       selected_task_id: taskId,
  //       loading: false,
  //     }));
  //   } catch (error) {
  //     console.error("Error fetching task data:", error);
  //     setState((prev) => ({ ...prev, loading: false }));
  //   }
  // };

  useEffect(() => {
    const socket = io(BASE_URL_NODE, {});
    setSocket(socket);

    socket.on("status-updated", (e) => {
      // setState((prev) => ({
      //   ...prev,
      //   models: prev.models.map((item) =>
      //     item.uid === e.uid ? { ...item, status: e.status } : item
      //   ),
      // }));
    });

    socket.on("transform-updated", (e) => {
      // setState((prev) => {
      //   const updatedModels = prev.models.map((item) =>
      //     item.uid === e.uid ? { ...item, aligned: true } : item
      //   );
      //   const updatedSelectedModel = updatedModels.find(
      //     (model) => model.uid === prev.selected_model?.uid
      //   );
      //   return {
      //     ...prev,
      //     models: updatedModels,
      //     selected_model: updatedSelectedModel,
      //   };
      // });
    });

    socket.on("close-editor", (e) => {
      // setState((prev) => ({
      //   ...prev,
      //   editorOpen: false, // Close the editor
      // }));
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    if (socket === null || state.selected_model === null) return;

    let copy_state = { ...state };

    let filtered_array = copy_state.models?.filter(
      (model) => model.status === copy_state.selected_status
    );

    let find_index = filtered_array.findIndex(
      (model) => model?.uid === copy_state?.selected_model?.uid
    );

    if (find_index === -1) {
      setState((prev) => {
        return {
          ...prev,
          selected_model: filtered_array[prev.selected_index],
        };
      });
    } else {
      setState((prev) => {
        return {
          ...prev,
          selected_index: find_index,
        };
      });
    }
  }, [socket, state.models]);

  return (
    <DataContext.Provider value={{ state, setState }}>
      {state.loading ? "Loading... " : children}
    </DataContext.Provider>
  );
};

// Helper function to clear task selection
export const clearTaskSelection = (setState) => {
  setState((prev) => ({
    ...prev,
    selected_task_id: "",
    models: [],
    selected_model: null,
    selected_index: null,
  }));
};

// Custom hook to use the DataContext
export const useData = () => useContext(DataContext);
